"use client";

import { useState } from "react";
import { signIn } from "next-auth/react";
import { Bot } from "lucide-react";

export default function LoginPage() {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(formData: FormData) {
    setLoading(true);
    setError(null);

    const result = await signIn("credentials", {
      email: formData.get("email"),
      password: formData.get("password"),
      redirect: false,
    });

    if (result?.error) {
      setError("Email ou mot de passe incorrect");
      setLoading(false);
    } else {
      window.location.href = "/";
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl shadow-sm border p-8">
          {/* Logo */}
          <div className="flex items-center gap-3 mb-8 justify-center">
            <div className="w-10 h-10 bg-violet-600 rounded-xl flex items-center justify-center shadow-lg">
              <Bot className="w-5 h-5 text-white" />
            </div>
            <div>
              <span className="font-bold text-lg text-gray-900">Dev Orchestrator</span>
              <p className="text-[10px] text-gray-400 uppercase tracking-widest leading-none">IA</p>
            </div>
          </div>

          <div className="mb-6">
            <h1 className="text-xl font-bold text-gray-900 text-center">Connexion</h1>
            <p className="text-gray-500 text-sm mt-1 text-center">
              Utilisez vos identifiants Chantiers BTP
            </p>
          </div>

          {error && (
            <div className="mb-5 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
              {error}
            </div>
          )}

          <form action={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                autoComplete="email"
                placeholder="vous@entreprise.fr"
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-violet-500/20 focus:border-violet-500 outline-none transition-all bg-gray-50/50"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1.5">
                Mot de passe
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                autoComplete="current-password"
                placeholder="••••••••"
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-violet-500/20 focus:border-violet-500 outline-none transition-all bg-gray-50/50"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 px-4 bg-violet-600 text-white font-medium rounded-lg hover:bg-violet-700 transition-colors disabled:opacity-50 text-sm mt-2"
            >
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </form>

          {/* Identifiants démo */}
          <div className="mt-6 pt-5 border-t border-gray-100">
            <p className="text-[11px] font-medium text-gray-400 uppercase tracking-wider text-center mb-2">
              Identifiants démo
            </p>
            <div className="bg-gray-50 rounded-lg p-3 text-xs text-gray-500 space-y-1 font-mono">
              <p><span className="text-gray-400">Email :</span> admin@orchestrator.local</p>
              <p><span className="text-gray-400">Mot de passe :</span> orchestrator2026</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
